import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { MobileCTABar } from './components/MobileCTABar';
import { HomePage } from './pages/HomePage';
import { HypothekenPage } from './pages/HypothekenPage';
import { WoonbotenPage } from './pages/WoonbotenPage';
import { VerzekeringenPage } from './pages/VerzekeringenPage';
import { OverOnsPage } from './pages/OverOnsPage';
import { KostenPage } from './pages/KostenPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={setCurrentPage} data-id="element-0" />;
      case 'hypotheken':
        return <HypothekenPage onNavigate={setCurrentPage} data-id="element-1" />;
      case 'woonboten':
        return <WoonbotenPage onNavigate={setCurrentPage} data-id="element-2" />;
      case 'verzekeringen':
        return <VerzekeringenPage onNavigate={setCurrentPage} data-id="element-3" />;
      case 'over-ons':
        return <OverOnsPage onNavigate={setCurrentPage} data-id="element-4" />;
      case 'kosten':
        return <KostenPage onNavigate={setCurrentPage} data-id="element-5" />;
      case 'contact':
        return <ContactPage onNavigate={setCurrentPage} data-id="element-6" />;
      default:
        return <HomePage onNavigate={setCurrentPage} data-id="element-7" />;
    }
  };
  return <div className="min-h-screen flex flex-col font-sans bg-white text-navy selection:bg-gold/30" data-id="element-8">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-gold focus:text-white focus:px-4 focus:py-2 focus:rounded-brand focus:font-bold" data-id="element-9">
        Ga naar inhoud
      </a>
      <Navbar currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-10" />

      <main id="main-content" className="flex-grow" data-id="element-11">
        <AnimatePresence mode="wait" data-id="element-12">
          <motion.div key={currentPage} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0
        }} transition={{
          enter: {
            duration: 0.3,
            ease: 'easeOut'
          },
          exit: {
            duration: 0.15,
            ease: 'easeIn'
          }
        }} data-id="element-13">
            {renderPage()}
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer onNavigate={setCurrentPage} data-id="element-14" />
      <MobileCTABar data-id="element-15" />
    </div>;
}